import {
  StyledFooter,
  StyledImg,
  StyledLegalDisclaim,
  StyledLegalLinks,
} from "./Footer.style";
import MerckLogo from "@src/assets/Merck.png";

function Footer() {
  const year = new Date().getFullYear();
  return (
    <StyledFooter>
      <StyledLegalLinks>
        <StyledImg src={MerckLogo} alt="Merck Logo" />
        <StyledLegalDisclaim variant="body-s">
          Copyright © {year} The life science business of Merck KGaA, Darmstadt,
          Germany operates as MilliporeSigma in the US and Canada. All Rights
          Reserved.
        </StyledLegalDisclaim>
      </StyledLegalLinks>
    </StyledFooter>
  );
}

export { Footer };
